// src/admin/components/WorkflowSelectionCard.js
import React from 'react';
import PropTypes from 'prop-types';
import { WorkflowTypeBadges } from '../../shared/components/WorkflowTypeBadge';

/**
 * WorkflowSelectionCard
 *
 * Displays a workflow’s name and description, and invokes onClick when picked.
 */
export default function WorkflowSelectionCard({ workflow, onClick }) {
  return (
    <div
      className="card mb-2 shadow-sm"
      role="button"
      onClick={() => onClick(workflow)}
    >
      <div className="card-body">
        <div className="d-flex align-items-center justify-content-between mb-1">
          <h6 className="mb-0 fw-semibold">{workflow.name}</h6>
          <WorkflowTypeBadges workflow={workflow} />
        </div>
        <p className="mb-0 text-muted small">{workflow.description}</p>
      </div>
    </div>
  );
}

WorkflowSelectionCard.propTypes = {
  workflow: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    user_workflow: PropTypes.bool,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};